export default __webpack_public_path__ + "static/media/solution_success_murder_icon.c77bdec3.svg";